import React, { PropsWithChildren, useEffect, useRef } from "react"
import { createPortal } from "react-dom"

type IconPortalProps = {
    position: {
        top: number | null
        left: number | null
    }
    size: number
}

export function IconPortal({ position, size, children }: IconPortalProps & PropsWithChildren) {
    const el: HTMLElement = document.createElement("div")
    const wrapper: React.RefObject<HTMLElement | null> = useRef(el)

    useEffect(() => {
        const current = wrapper.current as HTMLElement
        current.setAttribute("id", "icon-portal")
        document.body.appendChild(current)

        return () => {
            document.body.removeChild(current)
        }
    }, [])

    if (!wrapper.current || !children) {
        return null
    }

    return createPortal(
        <div
            className="absolute pointer-events-none"
            style={{
                height: `${size}px`,
                width: `${size}px`,
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}
        >
            {children}
        </div>,
        wrapper.current
    )
}
